const embedPdf = () => {
  const mainElement = document.createElement('main');
  const h1Element = document.createElement('h1');
  h1Element.textContent = 'Resume';

  const embedElement = document.createElement('embed');
  embedElement.src = 'src\Ashvin Valentine - CV Jan 24.pdf';
  embedElement.type = 'application/pdf';
  embedElement.width = '100%';
  embedElement.height = '600px';

  mainElement.appendChild(h1Element);
  mainElement.appendChild(embedElement);

  document.body.appendChild(mainElement);
};

embedPdf();

export default embedPdf;